import React from 'react';
import { useChangesSummaryMapper } from '../../../hooks/useChangesSummaryMapper';
import { LpBuilderFormMode } from '../../../constants';
import { ILandingPageBuilderBulkEditFormData } from '../../../helpers/getInitialLandingPageValuesForBulkEdit';
import { ChangedFieldsForm } from './ChangedFieldsForm';

interface ILandingPageChangedFieldsSummaryProps {
  values: ILandingPageBuilderBulkEditFormData;
  mode: LpBuilderFormMode;
}

export const LandingPageChangedFieldsSummary = ({
  values,
  mode,
}: ILandingPageChangedFieldsSummaryProps) => {
  const CHANGES_SUMMARY_MAPPER = useChangesSummaryMapper(values, mode);
  return (
    <>
      {CHANGES_SUMMARY_MAPPER.map(form => (
        <ChangedFieldsForm key={form.form} form={form} values={values} />
      ))}
    </>
  );
};
